import { RoutePath } from '@/src/RoutePath';
import HomePage from '@/src/components/event-templates-catalog/HomePage/HomePage';
import { UserGuide } from '@/src/components/faq/user-guide/UserGuide';
import { OAuthRedirectPage } from '@/src/pages/oauth2';
import { useFlashbars } from '@/src/store/flashbar.context';
import { useToolPanel } from '@/src/store/tool-panel.context';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import routes, { CHALLENGE_DETAILS_ROUTES } from '../../routes';
import ChallengeResources from '../challenges/challengeDetailSections/challengeCFNTemplate/ChallengeResources';
import ChallengeSnippets from '../challenges/challengeDetailSections/challengeCFNTemplate/ChallengeSnippets';
import SSHAccess from '../challenges/challengeDetailSections/challengeCFNTemplate/SSHAccess';
import ChallengeShowIAMPolicyDetail from '../challenges/challengeDetailSections/challengeIAMPolicy/ShowIAMPolicy';
import { NoMatch } from '../common/NoMatch/NoMatch';
import FAQ from '../faq/FAQ';
import { JamProfileCheckGuard } from '../game/Account/JamProfileCheckGuard';
import RestrictedRoute from './RestrictedRoute';

/* Main content to show the user if they are authenticated. */
const AllJamRoutes: React.FC = () => {
  const location = useLocation();
  const { clearFlashbars } = useFlashbars();
  const { toggleToolPanel, aiTeammateChatIsVisible } = useToolPanel();

  useEffect(() => {
    if (!aiTeammateChatIsVisible) {
      toggleToolPanel(false);
    }
    clearFlashbars();
  }, [location.pathname]);

  return (
    <JamProfileCheckGuard>
      <Switch>
        {/* Unauthenticated Routes */}
        <Route exact path={RoutePath.ROOT} component={HomePage} />
        <Route exact path={RoutePath.SIGNOUT}>
          <Redirect to={RoutePath.ROOT} />
        </Route>
        <Route exact path={RoutePath.OAUTH2} component={OAuthRedirectPage} />
        <Route exact path={RoutePath.FAQ} component={FAQ} />
        <Route exact path={RoutePath.USER_GUIDE} component={UserGuide} />
        <Route exact path={RoutePath.CHALLENGE_SNIPPETS} component={ChallengeSnippets} />
        <Route exact path={RoutePath.CHALLENGES_RESOURCES} component={ChallengeResources} />
        <Route
          exact
          path={CHALLENGE_DETAILS_ROUTES.ShowIamPolicy.wildcard()}
          component={ChallengeShowIAMPolicyDetail}
        />
        <Route exact path={RoutePath.SSH_ACCESS} component={SSHAccess} />
        <Route exact path={RoutePath.JAM_403}>
          <NoMatch path={RoutePath.JAM_403} />
        </Route>
        <Route exact path={RoutePath.JAM_404}>
          <NoMatch path={RoutePath.JAM_404} />
        </Route>
        <Route exact path={RoutePath.JAM_500}>
          <NoMatch path={RoutePath.JAM_500} />
        </Route>
        {/* Authenticated Routes */}
        {routes
          .filter((r) => !r?.disabled)
          .map(({ path, exact, Component, requiredGroups }, key) => {
            return (
              <RestrictedRoute
                exact={exact}
                path={path}
                key={key}
                requiredGroups={requiredGroups}
                component={Component}
              />
            );
          })}
        <Route path="*">
          <Redirect to={{ pathname: RoutePath.JAM_404 }} />
        </Route>
      </Switch>
    </JamProfileCheckGuard>
  );
};

export default AllJamRoutes;
